import { useEffect, useState } from 'react'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import FeeModelsDisplay from 'src/mentor/components/ActiveFeeModels/components/FeeModelsDisplay'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getSPDataWithParams } from 'src/supportPortal/services/services'

export default function ClinicEngagementModels({
  clinicBrandData,
  hideClinicBrandDropDown = false,
}) {
  const [selectedClinicBrand, setSelectedClinicBrand] = useState(clinicBrandData)
  const [loading, setLoading] = useState(false)
  const [allClinicBrands, setAllClinicBrands] = useState()
  const [loadingModels, setLoadingModels] = useState(false)
  const [entityFeeModels, setEntityFeeModels] = useState()
  const [inApplicableEntityFeeModels, setInApplicableEntityFeeModels] = useState()
  const [feeModels, setFeeModels] = useState()
  const [feeModelGroups, setFeeModelGroups] = useState()

  async function getAllClinicBrands() {
    const resp = await getSPDataWithParams(`/api/secure/cc/support/clinic-brand/list`, {})
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const brands = getDataMapFromCommonResponse(resp)?.['clinic-brand']
        setAllClinicBrands(brands)
      }
    }
  }
  async function getFeeModels() {
    const resp = await getSPDataWithParams(
      '/api/secure/cc/support/entity-fee-model/clinic-brand/list',
      {
        clinicBrandId: selectedClinicBrand?.id,
      },
    )
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setEntityFeeModels(data?.['entity-fee-model'])
        setInApplicableEntityFeeModels(data?.['inApplicable__entity-fee-model'])
        setFeeModels(data?.['fee-model'])
      }
    }
  }

  async function getFeeModelGroups() {
    const resp = await getSPDataWithParams(
      '/api/secure/cc/support/entity-fee-model/fee-model-group/list',
    )
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setFeeModelGroups(data?.['fee-model-group'])
      }
    }
  }

  async function setup() {
    setLoading(true)
    const setupTasks = [getFeeModelGroups()]
    if (!hideClinicBrandDropDown) {
      setupTasks.push(getAllClinicBrands())
    }
    await Promise.all(setupTasks)
    setLoading(false)
  }

  //   setEntityFeeModels
  useEffect(() => {
    setup()
  }, [])

  useEffect(() => {
    setSelectedClinicBrand(clinicBrandData)
  }, [clinicBrandData])

  async function getModels() {
    if (selectedClinicBrand && selectedClinicBrand?.id) {
      setLoadingModels(true)
      await getFeeModels()
      setLoadingModels(false)
    }
  }

  useEffect(() => {
    getModels()
  }, [selectedClinicBrand])

  return (
    <div className="d-flex flex-column h-100">
      <SupportHeader
        heading="Clinic Engagement Models"
        // subHeading="View and download clinic payout reports"
      />
      <div
        className="d-flex gap-2 p-2"
        style={{ maxWidth: '1200px', width: '100%', margin: '0 auto' }}
      >
        {!hideClinicBrandDropDown && (
          <CustomSelect
            value={selectedClinicBrand}
            options={allClinicBrands?.sort(
              (a, b) =>
                a?.brandName?.localeCompare(b?.brandName) || a?.title?.localeCompare(b?.title),
            )}
            label="Clinic Brand"
            getOptionValue={(optn) => optn?.id}
            getOptionLabel={(optn) => optn?.brandName || optn?.title}
            selectType={selectTypes.object}
            onChangeEvent={(e) => setSelectedClinicBrand(e.target.value)}
            id="clinicBrand"
            isLoading={loading}
          />
        )}
      </div>
      {selectedClinicBrand && selectedClinicBrand?.id ? (
        <FeeModelsDisplay
          entityFeeModels={entityFeeModels}
          inApplicableEntityFeeModels={inApplicableEntityFeeModels}
          feeModels={feeModels}
          feeModelGroups={feeModelGroups}
          forMentor={false}
          loading={loadingModels}
        />
      ) : (
        <div className="px-4">
          <h4>Please choose a clinic brand to continue</h4>
        </div>
      )}
    </div>
  )
}
